@if (params.isEditing()) {
  @let context = params.editContext();

  <ng-select
    [(ngModel)]="context[params.node.rowIndex].status"
    [items]="locationStatuses"
    bindValue="value"
    bindLabel="name"
    appendTo="body"
    class="w-full"
    placeholder="Status..."
    [clearable]="false"
    [disabled]="params.isSaving()"
  ></ng-select>
} @else {
  {{ getLocationStatus(params.data) }}
}
